"use client";

import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useState } from "react";
export default function Metodo() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: progressRef,
    isVisible: progressVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const [progressValue, setProgressValue] = useState(0);
  useEffect(() => {
    if (progressVisible) {
      const timer = setTimeout(() => setProgressValue(70), 200);
      return () => clearTimeout(timer);
    }
  }, [progressVisible]);
  const steps = [{
    number: "01",
    title: "Analisi metodologica del sito",
    description: "Analisi in situ degli impianti, verifica dello stato di conservazione e mappatura dei componenti critici.",
    duration: "1 giorno – ottimizzato per conformità normativa"
  }, {
    number: "02",
    title: "Ispezione video programmata",
    description: "Video-ispezione interna dei condotti per identificare accumuli, ostruzioni e criticità strutturali.",
    duration: "2 giorni – protocollo tecnico strutturato"
  }, {
    number: "03",
    title: "Piano di programmazione operativa",
    description: "Definizione delle procedure di riqualificazione igienico-funzionale personalizzate per il vostro impianto.",
    duration: "3 giorni – efficienza di processo garantita"
  }, {
    number: "04",
    title: "Intervento di manutenzione programmata",
    description: "Esecuzione della bonifica tecnica mediante tecnologie avanzate e robotica di precisione.",
    duration: "5 giorni – esecuzione tecnica rigorosa"
  }, {
    number: "05",
    title: "Verifica tecnica e report",
    description: "Test di efficienza finale e consegna del report fotografico dettagliato prima/dopo l'intervento.",
    duration: "1 giorno – validazione finale sistematica"
  }];
  return <section data-section-id="270" id="il-metodo-operativo-aera" className="relative overflow-hidden py-32 bg-background text-foreground">
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl">
        {}
        <div ref={headerRef} className={`max-w-3xl mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-xs font-mono uppercase tracking-[0.2em] mb-6 text-primary">
            — Metodo Operativo
          </p>
          <h2 className="font-default text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6 text-secondary">
            Dall'analisi tecnica alla{" "}
            <em className="italic text-primary">
              riqualificazione certificata.
            </em>
          </h2>
          <p className="font-default text-base lg:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            Implementiamo un framework metodologico avanzato basato su rigore analitico e protocolli certificati, progettato per massimizzare l'efficienza sistemica degli impianti HVAC e la resilienza igienica degli ambienti.
          </p>
        </div>

        {}
        <div ref={timelineRef} className="relative">
          {}
          <div className="hidden lg:block absolute top-[50%] left-0 right-0 h-px bg-primary" />

          {}
          <div className="lg:hidden absolute top-0 bottom-0 left-6 w-px bg-primary" />

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-4 relative">
            {steps.map((step, i) => <div key={i} data-index={i} className={`relative transition-all duration-700 ease-out ${timelineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 120}ms`
          }}>
                {}
                <div className="hidden lg:flex absolute top-[calc(50%-6px)] left-1/2 -translate-x-1/2 z-10">
                  <span className="block w-3 h-3 rounded-lg bg-primary shadow-md" />
                </div>

                {}
                <div className="lg:hidden absolute top-6 left-6 -translate-x-1/2 z-10">
                  <span className="block w-3 h-3 rounded-lg bg-primary shadow-md" />
                </div>

                <Card className="lg:mb-12 ml-14 lg:ml-0 p-6 rounded-lg border border-border bg-card hover:bg-accent transition-colors duration-300 gap-0 shadow-md">
                  <div className="font-default text-5xl mb-4 leading-none text-primary">
                    {step.number}
                  </div>
                  <h3 className="font-default text-xl mb-3 text-secondary leading-snug">
                    {step.title}
                  </h3>
                  <p className="font-default text-sm text-muted-foreground leading-relaxed line-clamp-2">
                    {step.description}
                  </p>
                </Card>
              </div>)}
          </div>
        </div>

        {}
        <div ref={progressRef} className={`mt-24 max-w-2xl mx-auto transition-all duration-1000 ease-out ${progressVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Progress value={progressValue} className="h-1 bg-muted [&>[data-slot=progress-indicator]]:bg-primary transition-all duration-[1500ms] ease-out" />
          <p className="font-default text-sm text-foreground mt-6 text-center font-medium">
            Ogni intervento viene pianificato in funzione della tipologia dell'impianto, del livello di contaminazione e delle esigenze operative del cliente.
          </p>
          <p className="font-default text-xs text-muted-foreground mt-4 text-center">
            Dal sopralluogo tecnico alla consegna del report finale, garantiamo interventi rapidi e conformi agli standard normativi.
          </p>
        </div>
      </div>
    </section>;
}